import { LIMPAR_USUARIOS_VENDEDORES } from '../types'

export default function limparUsuariosVendedores() {
  return {
    type: LIMPAR_USUARIOS_VENDEDORES,
  }
}
